import axios from "axios";
import { useEffect, useState } from "react";
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';

const App = () => {

  const [products, setProducts] = useState([]);

  useEffect(() => {
    const getProducts = async () => setProducts(await axios({
      method: 'get',
      url: 'https://aukinkochile.com/web/wp-json/wc/v3/products?per_page=100',
      headers: {
        'Authorization': 'Basic Y2tfYjM3Y2FjZjA1OWJiNzY3MmU1ZWNjM2NmZGE1YTU1MDEzZmI4Mjk5OTpjc181NzhlYWM3NzNlNGRjOTJkNDc5MGMxMmZlNjk3MDY3ZWQ4OWRmNjY1',
      }
    }).then(response => response.data))

    getProducts()
  }, []);
  return (
    <>
      <div className="container">
        <div className="row">
          <h1>Catálogo</h1>
          <p>El diseño puede variar al que quieran, al igual que los filtros</p>
          {products.length === 0 && 'Cargando catálogo...'}
          {
            products.map((p, index) => {
              return (
                <>
                  <div className="col-md-3 my-3">
                    <div class="card" style={{ width: "18rem" }}>
                      <img src={p.images[0].src} class="card-img-top" alt={p.images[0].name} />
                      <div class="card-body">
                        <h5 class="card-title">{p.name}</h5>
                        {/* <p class="card-text"></p> */}
                        <a href={p.permalink} class="btn btn-primary">Ver en la web</a>
                      </div>
                    </div>
                  </div>
                </>
              )
            })
          }
        </div>
      </div>
    </>
  );
}

export default App;
